import { FC } from 'react'

import SettingsIcon from 'src/Assets/Svg/settings-outline.svg?react'

import { PrimaryLabel } from '../PrimaryLabel'

export const ManualMatchingLabel: FC = () => (
  <PrimaryLabel text={'Manual'}>
    <SettingsIcon />
  </PrimaryLabel>
)
